import React from "react";
import { useState, useCallback, useMemo } from "react";
import Button from "@mui/material/Button";
import TextField from "@mui/material/TextField";
import DeleteIcon from "@mui/icons-material/Delete";
import AddIcon from "@mui/icons-material/Add";
import { useGlobalStore } from 'hooks/useGlobalStore';
import { updateChoiceItemFields } from 'actions/modelActions';
import ErrorToolTip from "../../Common/ErrorToolTip";
import ConfirmationDialog from "components/ConfirmationDialog";
import { useStyles } from "./styles";
import { IconButton } from "@mui/material";

const defaultImages = { condition: "", name: "" };

export default function Images(props) {
  const classes = useStyles();

const getImagesSource = useMemo(() => {
  let imgInfo = props?.data?.img_info;
  if (typeof imgInfo === "string") {
    try {
      imgInfo = JSON.parse(imgInfo);
    } catch {
      imgInfo = [defaultImages];
    }
  }
  return imgInfo && imgInfo.length
    ? { ...props.data, img_info: imgInfo }
    : { img_info: [defaultImages] };
  // eslint-disable-next-line react-hooks/exhaustive-deps
}, [props?.data, props?.choiceID, props?.itemID]);

  const [itemWithImages, setImages] = useGlobalStore(getImagesSource, updateChoiceItemFields, { choiceID: props?.choiceID, itemID: props?.itemID, tabCategory: props?.tabName });

  const invalidConditionsArray = props?.syntaxCheck?.ImageCondition || [];
const invalidConditions = Array.isArray(invalidConditionsArray)
  ? invalidConditionsArray.reduce((acc, curr) => {
      acc[curr.value] = curr;
      return acc;
    }, {})
  : invalidConditionsArray;

  const [deleteIndex, setDeleteIndex] = useState(null);

  const handleModalClose = () => setDeleteIndex(null);

  const handleAddImage = () => {
    setImages((prevState) => ({
      ...prevState,
      img_info: [...prevState.img_info, defaultImages],
      edited: true,
    }));
  };

  const handleClickDelete = () => {
    setImages((prevState) => ({ ...prevState, img_info: prevState.img_info.filter((_, i) => i !== deleteIndex), edited: true }));
    handleModalClose();
  };

  const handleUpdateImg = (e, idx, type) => {
  const value = e.target.value;
  setImages(prevState => ({
    ...prevState,
    img_info: prevState.img_info.map((img, index) =>
      index === idx ? { ...img, [type]: value } : img
    ),
    edited: true,
  }));
};

  const imagesLength = itemWithImages?.img_info?.length > 1;
  const imgToDelete = itemWithImages?.img_info[deleteIndex]?.condition;

  return (
    <>
      <div className={classes.root}>
        {itemWithImages?.img_info?.map((img, index) => {
          const imageCondition = getImagesSource.img_info[index]?.condition || img.condition;

          return (
            <div key={index}>
              <TextField
                className={classes.messageWidth}
                variant="filled"
                margin="dense"
                multiline
                required
                disabled={props.isKBReadOnly}
                label="Image Condition"
                value={img.condition}
                onChange={(e) => handleUpdateImg(e, index, 'condition')}
                slotProps={{
                  input: {
                    classes: { input: classes.textarea },
                    disableUnderline: true
                  }
                }}
              />
              {(img.condition && img.name) && imagesLength && <IconButton disabled={props.isKBReadOnly} onClick={() => { setDeleteIndex(index) }} ><DeleteIcon className={props?.isKBReadOnly ? 'delete-icon-button-disabled' : classes.deleteIconButton}  style={{ cursor: 'pointer' }} /></IconButton>}
              {invalidConditions?.[imageCondition] && (<ErrorToolTip data={invalidConditions[imageCondition]} />)}
              <TextField
                className={classes.messageWidth}
                variant="filled"
                margin="dense"
                required
                multiline
                disabled={props.isKBReadOnly}
                label="Image Name"
                value={img.name}
                onChange={(e) => handleUpdateImg(e, index, 'name')}
                slotProps={{
                  input: {
                    classes: { input: classes.textarea },
                    disableUnderline: true
                  }
                }}
              />
            </div>
          )
        })}
        <Button variant="text" className={classes.addMsgButton} disabled={props.isKBReadOnly} onClick={handleAddImage}><AddIcon /> Add New Image</Button>
      </div>

      {deleteIndex !== null &&
        <ConfirmationDialog
          open={deleteIndex !== null}
          title="Delete Image"
          content={<>You are about to delete "<b>{imgToDelete}</b>" image condition.<br /> Are you sure you want to delete it?</>}
          onClose={handleModalClose}
          onConfirm={handleClickDelete}
          caption="Delete"
          bgColor="#BE1313"
        />
      }
    </>
  );
}